import { NgModule } from '@angular/core';
import { AngularFireAuth } from './auth';

@NgModule({
  providers: [ AngularFireAuth ]
})
export class AngularFireAuthModule { }
